module.exports = __webpack_public_path__ + "static/media/instagram.cb6db96f.svg";